<template>
  <div style="height:347px;width:100%;">
    <!-- <div class="chart-title">报警频率统计 TOP5</div> -->
		<title-msg :titleMsg="titleMsg"></title-msg>
    <div>
      <div>
        <div>
          <div :class="className" id="main" :style="{height:height,width:width}" />
        </div>
      </div>
      <!-- <no-data v-else></no-data> -->
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";
// import noData from "@/views/components/nodata";
import titleMsg from "../../../components/titleMsg";
export default {
  components: {
		// noData,
		titleMsg
  },
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "350px"
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
			titleMsg:'预警频率趋势',
      chart: null,
      activeName: "first",
      radio1: "近12小时"
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  updated() {
    if (this.chartData) {
      this.setOptions(this.chartData);
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(document.getElementById("main"));
      this.setOptions(this.chartData);
    },
    changeRadio(value) {
      // let time = value.replace(/[^\d]/g, "");
      // this.getAlarmChartStatistics(time);
    },
    setOptions({ timeList, siteCount } = chartData) {
      if (this.chart) {
        this.chart.clear();
        // this.chart = echarts.init(document.getElementById("main"));
      } else {
        this.chart = echarts.init(document.getElementById("main"));
			}
       var option = {
        // backgroundColor: "#fff",
        title: {
          text: "总次数（次）",
          left: "5%",
          top: "5%",
          textStyle: {
            color: "#fff",
            fontSize: 14
          }
        },
        legend: {
          show: true,
          icon: "circle",
          right: 15,
          top: 0,
          itemWidth: 6,
          itemHeight: 6,
          itemGap: 25
        },
        grid: {
          left: "40",
          right: "40",
          top: "13%",
          bottom: "3%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis"
        },
        xAxis: [
          {
            type: "category",
            data: timeList,
            axisLine: {
              lineStyle: {
                color: "#ddd"
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#666", //纵向网格线颜色
                width: 1,
                type: "dashed"
              }
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: "#ffffff"
              },
              margin: 15
            },
            boundaryGap: false
          }
        ],
        yAxis: [
          {
            type: "value",
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "#6db7d1"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#666", //纵向网格线颜色
                width: 1,
                type: "dashed"
              }
            }
          }
        ],
        series: [
          {
            // name: 'S',
            type: "line",
            data: siteCount,
            symbolSize: 6,
            symbol: "circle",
            smooth: true,
            lineStyle: {
              color: "#a4dcf5"
            },
            itemStyle: {
              normal: {
                color: "#a4dcf5",
                borderColor: "#a4dcf5"
              }
            },
            areaStyle: {
              color: "rgba(164,220,245,0.2)"
            },
            emphasis: {
              itemStyle: {
                color: {
                  type: "radial",
                  x: 0.5,
                  y: 0.5,
                  r: 0.5,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#a4dcf5"
                    },
                    {
                      offset: 0.4,
                      color: "#a4dcf5"
                    },
                    {
                      offset: 0.5,
                      color: "#fff"
                    },
                    {
                      offset: 0.7,
                      color: "#fff"
                    },
                    {
                      offset: 0.8,
                      color: "#fff"
                    },
                    {
                      offset: 1,
                      color: "#fff"
                    }
                  ]
                },
                borderColor: "#a4dcf5",
                borderWidth: 2
              }
            }
          }
        ]
      };
      this.chart.setOption(option);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style lang="scss" scoped>
.radio-group-box {
  text-align: center;
  margin-top: 20px;
}
.btn-box {
  display: flex;
  justify-content: center;
  margin-top: -25px;
  margin-left: 290px;
  span {
    display: inline-block;
    width: 80px;
    height: 33px;
    text-align: center;
    line-height: 32px;
    vertical-align: middle;
    cursor: pointer;
    &.btnMonth {
      background-color: #ffffff;
      border-radius: 16px 0px 0px 16px;
      border: solid 1px #209b9a;
      color: #209b9a;
    }
    &.btnYear {
      background-color: #ffffff;
      border-radius: 0px 16px 16px 0px;
      border: solid 1px #209b9a;
      color: #209b9a;
      margin-left: -5px;
    }
    &.active {
      background-color: #209b9a;
      border-radius: 16px 0px 0px 16px;
      color: #fff;
    }
    &.actives {
      background-color: #209b9a;
      // border-radius: 16px 0px 0px 16px;
      color: #fff;
    }
  }
}
.month-box {
  float: right;
  width: 310px;
  text-align: right;
  span {
    font-size: 16px;
    margin: 0 20px;
  }
  .one::before {
    content: "";
    height: 18px;
    width: 18px;
    background-color: #9b7fdb;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
  .two::before {
    content: "";
    height: 18px;
    width: 18px;
    background-color: #eb416d;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
  .three::before {
    content: "";
    height: 18px;
    width: 18px;
    background-color: #f9b83f;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
}
.summary {
  overflow: hidden;
  .totle {
    color: #666666;
    font-size: 14px;
    text-align: center;
  }
  .progress {
    width: 100%;
    text-align: center;
    //  margin-left: -45px;
    // margin-right: 10px;
    .el-progress {
      width: calc(100% - 120px);
      display: inline-block;
    }
  }
}
</style>
